import {FC} from 'react'
import clsx from 'clsx'
import {KTSVG} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  href?: string
  title: string
  icon: string
  target?: '_blank'
  disabledTitle?: string
}

const AsideMenuExternalItem: FC<Props> = ({href, title, icon, target, disabledTitle}) => {
  const {config} = useLayout()
  const content = <>
    {config.aside.menuIcon === 'svg' && <span className='menu-icon'><KTSVG path={icon} className='svg-icon-2' /></span>}
    <span className='menu-title'>{title}</span>
  </>

  return <div className='menu-item'>
    {href ? (
      <a className='menu-link without-sub' href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>{content}</a>
    ) : (
      <span className={clsx('menu-link without-sub opacity-50')} aria-disabled='true' title={disabledTitle}>{content}</span>
    )}
  </div>
}

export {AsideMenuExternalItem}

